var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrSuriname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_23251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9902 0H-0.00976562V45H59.9902V0Z",
    fill: "#377E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9902 9H-0.00976562V36H59.9902V9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9902 13.5H-0.00976562V31.5H59.9902V13.5Z",
    fill: "#B40A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 14.3623L24.7127 30.6373L38.5596 20.5779H21.4408L35.2877 30.6373L30.0002 14.3623Z",
    fill: "#ECC81D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_23251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrSuriname);
export default __webpack_public_path__ + "static/media/sr Suriname.69afcb0d5312d1aea0b9217a08a5929b.svg";
export { ForwardRef as ReactComponent };